import find from 'lodash/find'
import map from 'lodash/map'
import React, { FC, memo } from 'react'

import { BaseAttribute, Product } from '@Generated/graphql'
import { useLocale } from '@Globals/Locale'
import { useTranslation } from '@Globals/Translations'

import styles from './GenericTextAttributeRenderer.module.scss'

export interface GenericAttributeRendererProps {
  asSection?: boolean
  attributeKeyName: string
  children?: React.ReactNode
  header: string
  includeHeader?: boolean
  product?: Product
  selectedVariantID?: string
}
export const GenericTextAttributeRenderer: FC<GenericAttributeRendererProps> = memo(({
  attributeKeyName,
  children,
  header,
  includeHeader,
  product,
  selectedVariantID,
}) => {
  const locale = useLocale()
  const { t } = useTranslation()
  const currentVariantData = (selectedVariantID && find(product?.variants, ['id', selectedVariantID])) || product?.masterVariant
  const textArray = ((find(currentVariantData?.attributes, ['key', attributeKeyName]) as BaseAttribute)?.value || [])

  const localizedText = textArray[locale] || ''

  if (!localizedText) {
    return null
  }

  return (
    <div>
      {includeHeader && <h2 className={styles.descriptionHeader}>{t(header)}</h2>}
      {map(
        localizedText.trim().split('\n'),
        (line, index) => {
          const trimmedData = line.trim()
          return trimmedData.length
            ? <div key={`${index}${line}`}>{trimmedData}</div>
            : null
        },
      )}
      {children}
    </div>
  )
})
